import React from "react";
import "./body.css";
import About from "./About";
import Projets from "./Projects";
import Skills from "./Skills";
import Work from "./Work";
import Contact from "./Contact";
import FASQ from "./Fasq";
import WhatDo from "./WhatDo";

function Body() {
  return (
    <div className="body">
      <section id="about">
        <About />
      </section>

      <section id="skill">
        <Skills />
      </section>

      <section id="work">
        <Work />
      </section>

     {/* <section id="whatdo">
       <WhatDo/>
     </section> */}

      <section id="project">
        <Projets />
      </section>

      <section id="faqs">
        <FASQ/>
      </section>

      <section id="contact">
        <Contact />
      </section>

      
    </div>
  );
}

export default Body;
